import LocalizedStrings from "react-localization";

import { en_IN } from "./Languages/English";

const strings = new LocalizedStrings({
  en_IN,
});

export default strings;
